// Re-export from shared with useSearchQuery hook injected
import SharedSearchCombobox, {
  SearchComboboxProps as SharedSearchComboboxProps,
  ItemBase,
  ComboxActions,
} from "@hydrologiq/shared/components/inputs/SearchCombobox"
import { useSearchQuery, QueryType } from "../../../hooks/useSearchQuery"

// Export types for consumers
export type { ItemBase, ComboxActions }

// Omit useSearchQuery from props since we inject it, and change queryType to our QueryType
type SearchComboboxProps<Item extends ItemBase> = Omit<
  SharedSearchComboboxProps<Item>,
  "useSearchQuery" | "queryType"
> & {
  queryType: QueryType
}

function SearchCombobox<Item extends ItemBase>(props: SearchComboboxProps<Item>) {
  return <SharedSearchCombobox {...props} useSearchQuery={useSearchQuery as any} />
}

export default SearchCombobox
